import ComponentStartAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentStart.mdx";
import UnlinkCardComponentUpdateCollectedDataAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_nolpay/unlinkCard/componentUpdateCollectedData.mdx";
import ComponentSubmitAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentSubmit.mdx";
import UnlinkCardComponentStepAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_nolpay/unlinkCard/componentStep.mdx";
import ComponentValidationStatusAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentValidationStatus.mdx";
import ComponentErrorAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/componentError.mdx";
import ViewModelStoreOwnerAndroid from "../../../../content/sdk/android/2.x.x/primerHeadlessUniversalCheckout/_common/viewModelStoreOwner.mdx";
import * as React from 'react';
export default {
  ComponentStartAndroid,
  UnlinkCardComponentUpdateCollectedDataAndroid,
  ComponentSubmitAndroid,
  UnlinkCardComponentStepAndroid,
  ComponentValidationStatusAndroid,
  ComponentErrorAndroid,
  ViewModelStoreOwnerAndroid,
  React
};